import { IPracticeAssignmentStatsResponse } from '../interfaces/reportingV2/ipractice-assignment-stats-response';
import { ICertificationAssignmentStatsResponse } from '../interfaces/reportingV2/icertification-assignment-stats-response';

type AssignmentStatsResponse = IPracticeAssignmentStatsResponse | ICertificationAssignmentStatsResponse;

export function filterAssignmentsByStatus<T extends AssignmentStatsResponse>(
  allStats: T[],
  selectedStatuses: string[]
): T[] {
  if (selectedStatuses.length === 0) {
    return [...allStats];
  }
  return allStats.filter(a => a.status && selectedStatuses.includes(a.status));
}
